import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { CHILD_PROFILES_DETAILS } from './url-constants';

type ChildProfileDetailsSaveEndpointSpecification = ApiEndpointSpecification;
export const ChildProfileDetailsSaveEndpointSpecification: ChildProfileDetailsSaveEndpointSpecification = {
    url: CHILD_PROFILES_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'ChildProfileDetailsRequestParams',
    requestBodySchemaName: 'ChildProfileDetailsRequestBody',
    okResponseSchemaName: 'ChildProfileDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeChildProfileDetails = Helpers.makeApiRequestFn<
    Types.ChildProfileDetailsRequestParams,
    Types.ChildProfileDetailsRequestBody,
    Types.ChildProfileDetailsOkResponse
>(ChildProfileDetailsSaveEndpointSpecification);
